
  import { Money } from 'v-money';

  export default {
    components: { MoneyField: Money },
    props: {
      constraints: { type: Object, default () { return {}; } },
      disabled: { type: Boolean, default: false },
      field: { type: String, required: true },
      filterButton: { type: Boolean, default: false },
      modelName: { type: String, required: true },
      placeholder: { type: String, default: null },
      validations: { type: Object, default: null },
      rangeMoney: { type: Boolean, required: false },
      required: { type: Boolean, default: false },
      step: { type: Number, default: null }
    },
    computed: {
      attribute: {
        get () {
          return this.$formGet(this.modelName, this.field) || 0;
        },
        set (value) {
          if (this.$el) {
            this.validate();
          }
          if (this.filterButton) {
            this.$emit('input', value);
          } else if (this.$formGet(this.modelName, this.field) !== value) {
            const h = {};
            h[this.field] = value;
            this.$formSet(this.modelName, h);
          }
        }
      }
    },
    methods: {
      validate () {
        const input = this.$el.querySelector('input');
        const newVal = parseInt(input.value.replace(/\D+/g, ''), 10);
        if (this.constraints.max && newVal > this.constraints.max) {
          return input.setCustomValidity(this.$t('form.errors.maxValue', [this.$n(this.constraints.max, 'currencyRound')]));
        } else if (this.constraints.min && newVal < this.constraints.min) {
          return input.setCustomValidity(this.$t('form.errors.minValue', [this.$n(this.constraints.min, 'currencyRound')]));
        } else {
          input.setCustomValidity('');
        }
      }
    }
  };
